/** Brief 12, `Mijozlar`: the list, the card and its blocks. */
export const uzB12Clients = {
  "clients.title": "Mijozlar",
  "clients.scope.mine": "Mening mijozlarim",
  "clients.kpi.total": "Jami mijozlar",
  "clients.kpi.totalHint": "Bu oyda +{count}",
  "clients.kpi.returning": "Qaytib keluvchilar",
  "clients.kpi.returningHint": "2+ safar qilganlar",
  "clients.kpi.value": "O'rtacha mijoz qiymati",
  "clients.kpi.valueHint": "Barcha safarlar bo'yicha",
  "clients.kpi.dormant": "Uyqudagi mijozlar",
  "clients.kpi.dormantHint": "12 oydan beri safar yo'q",
  "clients.today.returnedHint": "Fikr so'rang, keyingi safarni taklif qiling",
  "clients.today.birthdayHint": "Shu hafta · tabrik yuboring",
  "clients.today.passportHint": "6 oy ichida · yangilashni eslating",
  "clients.today.yearAgoHint": "O'sha yo'nalish bo'yicha taklif",
  "clients.tab.all": "Hammasi",
  "clients.tab.mine": "Mening mijozlarim",
  "clients.tab.regular": "Doimiy",
  "clients.tab.vip": "VIP",
  "clients.tab.dormant": "Uyqudagi",
  "clients.tab.corporate": "Korporativ",
  "clients.search": "Ism, telefon yoki pasport",
  "clients.searchName": "Ism bo'yicha qidirish",
  "clients.filter.more": "Filtr",
  "clients.filter.birthMonth": "Tug'ilgan oy",
  "clients.filter.trips": "Safarlar soni, kamida",
  "clients.filter.total": "Jami summa, $ dan",
  "clients.filter.apply": "Qo'llash",
  "clients.filter.withoutOffer": "Taklif yuborilmagan",
  "clients.filter.empty": "Mos mijoz topilmadi. Filtrni o'zgartiring.",
  "clients.empty.title": "Mijozlar bazasi bo'sh",
  "clients.empty.body": "Excel yoki Google Sheets'dan mijozlarni import qiling yoki birinchisini qo'lda qo'shing.",
  "clients.empty.bodyAdd": "Birinchi mijozni qo'lda qo'shing.",
  "clients.empty.import": "Import qilish",
  "clients.empty.bodyRead": "Agentlik mijoz qo'shgach, ular shu yerda chiqadi.",
  "clients.error.title": "Mijozlar yuklanmadi",
  "clients.range": "{from}–{to} / {total}",
  "clients.prev": "Oldingi",
  "clients.next": "Keyingi",
  "clients.bulk.close": "Bekor qilish",
  "clients.row.open": "Mijoz kartasini ochish",
  "clients.card.back": "Orqaga",
  "clients.card.owner": "Mas'ul: {name}",
  "clients.card.thread": "Suhbat",
  "clients.card.newDeal": "Bitim yaratish",
  "clients.card.notFound": "Mijoz topilmadi yoki sizga ochiq emas.",
  "clients.card.toList": "Mijozlar ro'yxatiga",
  "clients.bron.title": "Bronlar",
  "clients.bron.section": "Bronlar bo'limi",
  "clients.bron.empty": "Bron hali yo'q",
  "clients.bron.search": "Tur qidirish",
  "clients.bron.travellers": "{count} turist",
  "clients.bron.mismatch": "Ism farqi. Pasportda: {passport} · Bronda: {booking}",
  "clients.bron.row.travellers": "Turistlar",
  "clients.bron.row.passport": "Pasport",
  "clients.bron.row.room": "Xona",
  "clients.bron.row.meal": "Ovqatlanish",
  "clients.bron.row.insurance": "Sug'urta",
  "clients.bron.row.extras": "Qo'shimcha",
  "clients.bron.row.provider": "Ta'minotchi",
  "clients.bron.row.note": "Izoh",
  "clients.bron.passportSoon": "{mask} · muddat yaqin, {date}",
  "clients.bron.outbound": "Borish",
  "clients.bron.inbound": "Qaytish",
  "clients.bron.page": "Bron sahifasi",
  "clients.bron.deal": "Bitim №{number}",
  "clients.bron.nights": "{count} kecha",
  "clients.trips.title": "Oldingi sayohatlar",
  "clients.trips.empty": "Hali biz bilan sayohat qilmagan.",
  "clients.trips.line": "{date} · {pax} kishi",
  "clients.portrait.title": "mijoz portreti",
  "clients.portrait.destination": "Yo'nalish",
  "clients.portrait.budget": "Byudjet",
  "clients.portrait.company": "Kim bilan",
  "clients.portrait.month": "Sayohat oyi",
  "clients.portrait.food": "Ovqat",
  "clients.portrait.unknown": "Ma'lumot yetarli emas",
  "clients.portrait.needMore": "AI portret uchun kamida 3 ta xabar yoki 1 ta bitim kerak",
  "clients.portrait.source": "Manba: {source} · {year} dan beri",
  "clients.portrait.since": "Manba: {year} dan beri",
  "clients.portrait.spouse": "Turmush o'rtog'i bilan",
  "clients.portrait.children": "{count} bola ({ages} yosh)",
  "clients.portrait.perPerson": "kishi boshiga",
  "clients.portrait.perTrip": "safarga",
  "clients.contact.title": "Aloqa",
  "clients.contact.phone": "Telefon",
  "clients.contact.channel": "Kanal",
  "clients.contact.owner": "Mas'ul",
  "clients.contact.group": "Guruh",
  "clients.contact.email": "Email",
  "clients.record.title": "Qisqa xulosa",
  "clients.record.deals": "Bitimlar",
  "clients.record.sum": "Summa",
  "clients.record.activity": "Oxirgi faollik",
  "clients.record.discipline": "Intizom",
  "clients.count": "{count} mijoz",
  "clients.mobile.trips": "{count} safar",
  "clients.error.bron": "Bronlar yuklanmadi",
  "clients.error.trips": "Sayohatlar yuklanmadi",
  "clients.error.portrait": "Portret yuklanmadi",
  "clients.table": "Mijozlar ro'yxati",
  "clients.new.mic": "Ovoz bilan kiritish",
  "clients.new.micFailed": "Ovozni tanib bo'lmadi",
  "clients.new.firstName": "Ism",
  "clients.new.lastName": "Familiya",
  "clients.new": "Yangi mijoz",
} as const;
